import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layout-row-fill",
  "use": "icon-layout-row-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-layout-row-fill\">\n<path d=\"M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7Z\" stroke=\"#42526E\" stroke-width=\"2\" />\n<rect x=\"7\" y=\"7\" width=\"10\" height=\"5\" fill=\"#42526E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol